import React from 'react';
import PropTypes from 'prop-types';
import { Translate, I18n } from 'react-redux-i18n';
import { TextField } from '@material-ui/core';
import { getFieldLabel } from '../../utils';
import PersonalDataProcessing from './PersonalDataProcessing';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SUBCONTRACTED_SERVICES_DETAILS_MAX_LENGTH = 1024;
function SubcontractedServices(_ref) {
  let {
    onChange,
    publicProcurementData
  } = _ref;
  const handleSimpleChange = name => event => {
    onChange({
      [name]: event.target.value
    });
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "card",
    children: [/*#__PURE__*/_jsx("div", {
      className: "flex-container",
      children: /*#__PURE__*/_jsx("h2", {
        children: /*#__PURE__*/_jsx(Translate, {
          value: "publicProcurement.titles.subcontractedServices"
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "row",
      children: /*#__PURE__*/_jsx("div", {
        className: "col-12 pb-3",
        children: /*#__PURE__*/_jsx(TextField, {
          label: getFieldLabel('publicProcurement.subcontractedServicesDetails', true),
          id: "subcontractedServicesDetails",
          name: "subcontractedServicesDetails",
          value: publicProcurementData.subcontractedServicesDetails || '',
          onChange: handleSimpleChange('subcontractedServicesDetails'),
          multiline: true,
          minRows: 3,
          maxRows: 10,
          inputProps: {
            maxLength: SUBCONTRACTED_SERVICES_DETAILS_MAX_LENGTH
          }
        })
      })
    }), /*#__PURE__*/_jsx(PersonalDataProcessing, {
      onChange: onChange,
      personalDataProcessing: publicProcurementData.personalDataProcessing
    }), /*#__PURE__*/_jsx("div", {
      className: "row pb-3",
      children: /*#__PURE__*/_jsx("div", {
        className: "col-12",
        children: /*#__PURE__*/_jsx(TextField, {
          id: "subcontractedServicesLocation",
          name: "subcontractedServicesLocation",
          label: I18n.t('publicProcurement.subcontractedServicesLocation'),
          value: publicProcurementData.subcontractedServicesLocation || '',
          onChange: handleSimpleChange('subcontractedServicesLocation')
        })
      })
    })]
  });
}
SubcontractedServices.propTypes = {
  onChange: PropTypes.func.isRequired,
  publicProcurementData: PropTypes.shape({
    subcontractedServicesDetails: PropTypes.string,
    subcontractedServicesLocation: PropTypes.string,
    personalDataProcessing: PropTypes.shape({
      services: PropTypes.string,
      duration: PropTypes.string,
      process: PropTypes.string,
      purpose: PropTypes.string,
      dataType: PropTypes.string,
      targets: PropTypes.string,
      personalDataProtectionAgreement: PropTypes.bool,
      personalDataRegulationAgreement: PropTypes.bool
    })
  }).isRequired
};
export default SubcontractedServices;